import { createContext, useContext } from "react";
import useCompanySales from "../hooks/useCompanySales";

const CompanySalesContext = createContext(null);

export const CompanySalesContextProvider = ({ children }) => {
    const sales = useCompanySales();
    return (
        <CompanySalesContext.Provider value={sales}>
            {children}
        </CompanySalesContext.Provider>
    );
};

export const useCompanySalesContext = () => useContext(CompanySalesContext);

export default CompanySalesContext;
